/**
 * Today's words and the goals (part 19b log, tables D and G): which day a count is for, what a count's change makes of
 * today's words, what a typed goal reads as, and how far a count is towards its goal. Pure.
 */
import { MAX_GOAL, MAX_TODAY } from '../shell/settings.ts';
import type { BookWriting } from '../shell/settings.ts';

export { localDay } from './day.ts';

/** D6: today's words of `writing` on `day`: a count kept for another day is none. */
export function todayOf(writing: BookWriting, day: string): number {
  return writing.day === day ? writing.today : 0;
}

/** D2, D5, D6, D10: `writing`'s day and today's words once `change` (a count's change, either way) is added on `day`. */
export function addToday(writing: BookWriting, day: string, change: number): Pick<BookWriting, 'day' | 'today'> {
  return { day, today: Math.max(-MAX_TODAY, Math.min(MAX_TODAY, todayOf(writing, day) + change)) };
}

/** G2: digits, alone or in groups of three after the first, between them a space, comma, point or apostrophe. */
const GOAL = /^\d+$|^\d{1,3}(?:[\s,.'’]\d{3})+$/u;

/**
 * G2, G3: what a typed goal reads as: none for empty text, the number for digits (grouped or not) from 1 to
 * {@link MAX_GOAL}, or `refused` for anything else.
 */
export function readGoal(text: string): number | null | 'refused' {
  const trimmed = text.trim();
  if (trimmed === '') return null;
  if (!GOAL.test(trimmed)) return 'refused';
  const value = Number(trimmed.replace(/\D/gu, ''));
  return value >= 1 && value <= MAX_GOAL ? value : 'refused';
}

/** G5: how far `value` is towards `goal`, in whole percent rounded down; below 0 counts as 0, past 100 as it is. */
export function progress(value: number, goal: number): number {
  return Math.floor((Math.max(0, value) * 100) / goal);
}

/** G6: whether today's words went from `before` to `after` reach `goal` from below. */
export function reached(before: number, after: number, goal: number | null): boolean {
  return goal !== null && before < goal && after >= goal;
}
